// extracted by mini-css-extract-plugin
export default {"drawer":"GCv6TiiOVufgiMsP_UpQ__drawer___"};